import * as angular from 'angular';

"use strict";

angular.module('ReportsModule', [])

export default 'ReportsModule';